/**
 * BB Dynamic Banner — geo-aware top strip replacing static Vitals banners.
 * Rotates between: free-shipping threshold (state-specific), volume discount tip,
 * and the Arizona facility announcement.
 *
 * Reads geo from sessionStorage (set by bb-shipping-estimator.js) → IP fallback.
 * State-aware messaging with a graceful default when zone is unknown.
 */
(function () {
  'use strict';

  // Zone tables — kept in sync with bb-shipping-estimator.js (USA store)
  // 2026-07-30: was OUT OF SYNC with bb-shipping-estimator.js (CA sat in zone 1, ID/NV/AZ/NM
  // in zone 2, TX alone in 5). Harmless while every zone shared one flat ladder; with
  // distance-based rates it made the header quote a different price than checkout. Now mirrored.
    // ⭐⭐ THE STANDARD CARD, live 2026-10-21. ONLY the kept regions appear here. A region with
  //    no entry has no zone, no rate and no quote — which is the point: checkout refuses it too.
  //    The four zones remain because each 2027 hub will get its OWN four measured from itself;
  //    today they all carry the same price.
  // ⛔ Never add a paused region here without also adding it to the live delivery profiles.
  var ZONES = {
    'WA':1,'OR':1,'ID':1,
    'MT':2,'NV':2,'UT':2,'WY':2,'CA':2,
    'AZ':3,'CO':3,'NM':3,
    'TX':4,
    /* ⛔ PAUSED regions, present so getGeo() RECOGNISES them. getGeo gates on ZONES, so
       removing them made it return null and the bar fell to its no-geo "$149 Flat" line
       instead of the pause notice. The zone value is irrelevant — the pause branch runs
       first; every zone is $149/$199 anyway. */
    'CT':4,'DE':4,'DC':4,'FL':4,'GA':4,'IL':4,'IN':4,'IA':4,'KS':4,'KY':4,'LA':4,'ME':4,'MD':4,'MA':4,'MI':4,'MN':4,'MS':4,'MO':4,'NE':4,'NH':4,'NJ':4,'NY':4,'NC':4,'ND':4,'OH':4,'OK':4,'PA':4,'RI':4,'SC':4,'SD':4,'TN':4,'VT':4,'VA':4,'WV':4,'WI':4
  }
  // Full tier ladder per zone — kept in sync with bb-shipping-estimator.js RATES table.
  // min/rate stored in DOLLARS here (estimator uses cents).
  // Zones served by the new Arizona facility on day one
  var AZ_SERVED_ZONES = new Set([1, 2, 4, 5]);

  // LINKED 2026-05-26: the live ladder is read from bb-shipping-estimator.js
  // (window.BB_SHIP_RATES, in cents) via resolveTiers() — so one rate change in
  // the estimator updates this header banner too. The table below is only a
  // FALLBACK if the estimator hasn't loaded yet; keep it matched to the estimator.
  // FREIGHT REBUILD 2026-07-09: flat claw-back ladder (dollars), all zones identical,
  // matched to the estimator RATES. ONE LANE 2026-11-01: one flat $99, FREE over $2,500 (the zero sits at
  // bands[1]). Used only if BB_SHIP_RATES hasn't loaded.
  var _BB_FB_BANDS = [500, 2500, 5000, 5000, 10000, 15000, 25000]; // dollars — mirrors checkout
  function _bbF(d){ return d.map(function (v, i) { return { min: _BB_FB_BANDS[i], rate: v, label: v === 0 ? 'FREE' : '$' + v }; }); }
  var TIERS_FALLBACK = {
    1: _bbF([99, 0, 0, 0, 0, 0, 0]),
    2: _bbF([99, 0, 0, 0, 0, 0, 0]),
    3: _bbF([99, 0, 0, 0, 0, 0, 0]),
    4: _bbF([99, 0, 0, 0, 0, 0, 0])
  };
  /* ⭐ ONE OWNER of the lane, evaluated FRESH at every read. The bar re-renders on a variant
     change before the estimator recomputes window.__bbLaneCrane, and bb:ship-rate fires 0x on a
     PDP, so anything reading that global paints the PREVIOUS lane. data-bb-crane-ids is emitted
     by the estimator snippet from custom.shipping_mode — the field the delivery PROFILE bills on.
     ⛔ Cart truth wins when the cart has items; the PDP attribute is only for an empty cart. */
  function _bbLaneFresh() {
    try {
      var _cartKnown = window.__bbCartCraneKnown && window.__bbCartItemCount > 0;
      if (!_cartKnown) {
        var _el = document.getElementById('bb-ship-est-product');
        var _ids = _el && _el.getAttribute('data-bb-crane-ids');
        var _f = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (_ids !== null && _ids !== undefined && _f && _f.value) {
          return (' ' + _ids + ' ').indexOf(' ' + _f.value + ' ') !== -1;
        }
      }
    } catch (e) {}
    return (typeof window.__bbLaneCrane === 'boolean')
      ? window.__bbLaneCrane
      : (window.__bbNeedsCrane === true);
  }
  function resolveTiers() {
    // CRANE-AWARE (fixed 2026-08-01): the bar picks the service NAME from window.__bbNeedsCrane
    // but used to read the LOOSE ladder unconditionally, so a crane cart rendered
    // "Crane Delivery · from $49" — naming the $149 service at the $49 price. Read the matching
    // table. If BB_CRANE_RATES is missing we fall back to loose, which understates rather than
    // overstates: the safe direction for a public claim.
    /* ⭐ prefer the estimator's PUBLISHED lane (cart truth, else the VIEWED variant).
       __bbNeedsCrane is cart-only, so on a PDP with an empty cart this returned the LOOSE
       ladder and every message read "from $49" under a $99 crane variant. */
    var _bbCrane = _bbLaneFresh();   /* fresh, not the possibly-stale global */
    // MIXED CART (2026-08-13): Shopify bills ONE RATE PER DELIVERY PROFILE, evaluated against the
    // WHOLE cart, so a cart spanning both lanes pays quick + crane — $198, verified live against
    // /cart/shipping_rates.json. This picked ONE ladder and so undercut checkout by up to $149.
    // The estimator owns the sum; read it rather than re-adding the ladders here. If it has not
    // loaded we keep the old binary answer, which understates rather than inventing a number.
    /* ⭐ metafield truth first — __bbCartLanes was a title-regex guess that missed heavy items
       whose names carry no crane keyword, quoting a mixed cart at the Light rate. */
    var _bbTruth = (typeof window !== 'undefined') && window.__bbCartLanesTruth;
    var _bbLanes = (_bbTruth && typeof _bbTruth.loose === 'boolean')
      ? _bbTruth
      : ((typeof window !== 'undefined') && window.__bbCartLanes);
    var _bbMixed = !!(_bbLanes && _bbLanes.loose && _bbLanes.crane);
    var r = (_bbMixed && typeof window.BB_MIXED_RATES_FN === 'function')
      ? window.BB_MIXED_RATES_FN()
      : ((_bbCrane && window.BB_CRANE_RATES) ? window.BB_CRANE_RATES : window.BB_SHIP_RATES);
    if (r) {
      var o = {};
      for (var z in r) {
        o[z] = r[z].map(function (t) { return { min: Math.round(t.min / 100), rate: Math.round(t.rate / 100), label: t.label }; });
      }
      return o;
    }
    return TIERS_FALLBACK;
  }

  // FREE-TIER TRUTH GATE 2026-08-12: the newly-opened Loose Truck zones have NO free band at any
  // cart value, so this suffix must never render there. The West keeps the claim in full.
  var _BB_FREE_HTML = '';
  /* The free offer as a STANDALONE bar message, for mobile where no inline suffix fits.
     Threshold is DERIVED from the first $0 band; a min of 0 is rejected. */
  function _bbFreeMsg(t) {
    if (!t || !t.length) return '';
    for (var i = 0; i < t.length; i++) {
      if (+t[i].rate === 0 && +t[i].min > 0) {
        return '\uD83D\uDE9A <span style="font-weight:800"><span style="color:#FF8A5C">FREE</span> Delivery Over <span style="color:#FF8A5C">' + money(+t[i].min) + '</span></span>';
      }
    }
    return '';
  }

  function _bbFreeSuffix(t, mobile) {
    if (!t || !t.length) return '';
    /* ⭐ FREE DELIVERY AT $2,500+ WENT LIVE 2026-09-18 (owner-approved, all four zones, verified
       on all 42 live zone-lanes). This used to fail closed and return '' because no free tier
       existed. The threshold is DERIVED from the first $0 band in the tier table, so a reprice
       carries it automatically and this can never state a stale number.
       ⛔ A band with min 0 is rejected — that would advertise free delivery on every order. */
    for (var i = 0; i < t.length; i++) {
      if (+t[i].rate === 0 && +t[i].min > 0) {
        /* ⛔ MOBILE MUST BE SHORT. Appending the desktop string to the mobile branch wrapped the
           bar onto two lines on a live phone. The mobile branch is deliberately terse, so the
           suffix has to be too. A round-thousand threshold compresses to "$5k+"; anything else
           prints exactly, because rounding a threshold DOWN would understate what the shopper
           has to spend. */
        var _m = +t[i].min;
        /* ⛔ NO INLINE SUFFIX ON MOBILE AT ANY LENGTH. Measured at the bar's real font against a
           ~296px phone content budget: the geo line alone is already 278px, "FREE over $5,000"
           takes it to 423px and even "FREE $5k+" to 367px. Both wrap. The offer is shown on
           mobile as its OWN rotating message instead - see _bbFreeMsg / refresh(). */
        if (mobile) return '';
        /* "over" sits OUTSIDE the orange span so it inherits the bar's own text colour,
           matching "Delivered & Unloaded" and "for" exactly rather than guessing a white. */
        return ' · <span style="color:#FF8A5C;font-weight:800">FREE</span>'
             + '<span style="font-weight:800"> </span>'
             + '<span style="color:#FF8A5C;font-weight:800">' + money(_m) + '+</span>';
      }
    }
    return '';
  }

  var STATE_NAMES = {
    'AL':'Alabama','AK':'Alaska','AZ':'Arizona','AR':'Arkansas','CA':'California','CO':'Colorado','CT':'Connecticut','DE':'Delaware','DC':'Washington DC','FL':'Florida','GA':'Georgia','HI':'Hawaii','ID':'Idaho','IL':'Illinois','IN':'Indiana','IA':'Iowa','KS':'Kansas','KY':'Kentucky','LA':'Louisiana','ME':'Maine','MD':'Maryland','MA':'Massachusetts','MI':'Michigan','MN':'Minnesota','MS':'Mississippi','MO':'Missouri','MT':'Montana','NE':'Nebraska','NV':'Nevada','NH':'New Hampshire','NJ':'New Jersey','NM':'New Mexico','NY':'New York','NC':'North Carolina','ND':'North Dakota','OH':'Ohio','OK':'Oklahoma','OR':'Oregon','PA':'Pennsylvania','RI':'Rhode Island','SC':'South Carolina','SD':'South Dakota','TN':'Tennessee','TX':'Texas','UT':'Utah','VT':'Vermont','VA':'Virginia','WA':'Washington','WV':'West Virginia','WI':'Wisconsin','WY':'Wyoming'
  };

  function money(n) { return '$' + Math.round(n).toLocaleString('en-US'); }

  /* Reads the shared cache. The city-ownership rule that used to live here —
     only trust a city stamped for THIS region — moved into BBGeo.get(), which
     enforces it against both the bb_geo_city_st and bb_geo_city_ok stamps.
     ZONES stays here: BBGeo answers "where", this file answers "do we serve it". */
  function getGeo() {
    var g = window.BBGeo ? window.BBGeo.get() : null;
    if (!g || !g.state) return null;
    if (ZONES[g.state]) return { state: g.state, city: g.city || '', zone: ZONES[g.state] };
    return null;
  }

  // State known, city missing — enrich from the shared IP path.
  function fetchCityIfMissing(cb) {
    if (!window.BBGeo) { cb(); return; }
    window.BBGeo.resolveIP(function (ip) {
      if (ip && ip.city && ip.region && ZONES[ip.region]) {
        window.BBGeo.set({ region: ip.region, city: ip.city, source: 'ip' }, { silent: true });
      }
      cb();
    });
  }

  function detectGeoIfMissing(cb) {
    var geo = getGeo();
    if (geo && geo.city) { cb(geo); return; }
    if (geo && !geo.city) {
      // State known, city missing — enrich, then re-read
      fetchCityIfMissing(function () { cb(getGeo()); });
      return;
    }
    if (!window.BBGeo) { cb(null); return; }
    window.BBGeo.resolveIP(function (ip) {
      if (ip && ip.region && ZONES[ip.region]) {
        window.BBGeo.set({ region: ip.region, city: ip.city, source: 'ip' }, { silent: true });
        cb({ state: ip.region, city: ip.city || '', zone: ZONES[ip.region] });
      } else {
        cb(null);
      }
    });
  }

  function locationLabel(geo) {
    if (!geo) return null;
    // Match estimator behavior: "City, State" if both, otherwise state abbreviation.
    // Spelled out when only a code is known — a manually entered ZIP/postal has no city, and
    // "Now Delivering to NY" reads like a database field rather than a place.
    // Always the FULL region name, with or without a city, so the bar and the PDP match.
    var _rn = STATE_NAMES[geo.state] || geo.state;
    // "Beverly Hills, CA" reads local; the full state name is the fallback when we have no city.
    return geo.city ? (geo.city + ', ' + geo.state) : _rn;
  }

  /* ⭐ "to" a town, "in" a region. Decided from the LABEL, not from the branch: a comma means
   "City, ST" (so "to Summerland, BC"), no comma means a state/province name or code (so
   "in British Columbia" / "in BC"). Label-driven so it cannot drift when a branch is edited. */
/* ⭐ DELIVERY ETA — owner 2026-09-23: work the delivery ETA into the freight bar.
   ⛔ It is its OWN rotating message, NEVER an inline suffix. The geo line alone already measures
      278px of a ~296px phone content budget, so any inline addition wraps — proved twice, see
      _bbFreeSuffix. Desktop gets the longer form; mobile stays terse.
   ⛔ Read ONLY from the estimator's PUBLISHED tables. Lead times differ per STORE and per ZONE,
      and a zone present in ZONES but absent from the ETA table renders "undefined" — so a missing
      zone returns '' (no message) rather than a guess. Never hardcode a week count here.
   ⛔ USA publishes BB_ZONE_ETA (crane) AND BB_ZONE_QS_ETA (loose) for all 8 zones, so the window
      follows the lane. CA publishes ONLY BB_ZONE_QS_ETA; CA's crane and loose windows are equal
      per zone, so the loose table is right for both there. CA's in-file ZONE_ETA is NOT published,
      covers 4 of its 6 zones and disagrees with the shipped card — do not reach for it.
   ⭐ Shows a real ARRIVAL WINDOW, not a week count: owner 2026-08-12, "week counts read as
      sticker shock". Same shape the newzone branch already computed but never actually rendered. */
  /* ⛔ BUSINESS DAYS, NOT CALENDAR — checkout counts processingTime (P10D = 10 business
     days) + transit in business days. Adding calendar days made this promise EARLIER than
     checkout in every zone. Weekends skipped; holidays are not modelled, which errs LATE
     (safe) rather than early. */
  /* ⛔ HOLIDAYS SKIPPED TO MATCH CHECKOUT, NOT BECAUSE WE STOP (owner 2026-10-17: "it's not
     like our trucks stop on holidays they're out on the road"). Shopify's checkout date DOES skip
     them and the customer sees both numbers in one session. Measured on a Maryland cart:
     storefront Dec 11-25 vs checkout Dec 17-Jan 4, which reconciles to exactly +1 business day
     once these days come out. Matching them closes the visible gap and errs LATE.
     ⛔⛔ DO NOT re-base transit to calendar days to "be honest about 7-day trucking". The card is
     business days end to end: "2-4 weeks" IS 10-20 business days and the LOW bound is processing
     alone, which is why processing can never exceed 10bd. A 7-day transit basis breaks every
     published label (Light Z1 2-4 -> 2-3.4 wks). */
  var _BB_HOL = {"2026-01-01":1,"2026-01-19":1,"2026-02-16":1,"2026-05-25":1,"2026-06-19":1,"2026-07-03":1,"2026-09-07":1,"2026-10-12":1,"2026-11-11":1,"2026-11-26":1,"2026-11-27":1,"2026-12-25":1,"2027-01-01":1,"2027-01-18":1,"2027-02-15":1,"2027-05-31":1,"2027-06-18":1,"2027-07-05":1,"2027-09-06":1,"2027-10-11":1,"2027-11-11":1,"2027-11-25":1,"2027-11-26":1,"2027-12-24":1,"2027-12-31":1,"2028-01-17":1,"2028-02-21":1,"2028-05-29":1,"2028-06-19":1,"2028-07-04":1,"2028-09-04":1,"2028-10-09":1,"2028-11-10":1,"2028-11-23":1,"2028-11-24":1,"2028-12-25":1,"2029-01-01":1,"2029-01-15":1,"2029-02-19":1,"2029-05-28":1,"2029-06-19":1,"2029-07-04":1,"2029-09-03":1,"2029-10-08":1,"2029-11-12":1,"2029-11-22":1,"2029-11-23":1,"2029-12-25":1,"2030-01-01":1,"2030-01-21":1,"2030-02-18":1,"2030-05-27":1,"2030-06-19":1,"2030-07-04":1,"2030-09-02":1,"2030-10-14":1,"2030-11-11":1,"2030-11-28":1,"2030-11-29":1,"2030-12-25":1,"2031-01-01":1,"2031-01-20":1,"2031-02-17":1,"2031-05-26":1,"2031-06-19":1,"2031-07-04":1,"2031-09-01":1,"2031-10-13":1,"2031-11-11":1,"2031-11-27":1,"2031-11-28":1,"2031-12-25":1};
  function _bbAddBd(n) {
    var d = new Date(); var i = 0;
    while (i < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w === 0 || w === 6) continue;
      if (_BB_HOL[d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2)]) continue;
      i++;
    }
    return d;
  }
  function _bbEtaMsg(geo, mobile, cartTotalCents) {
    try {
      if (!geo || !geo.state) return '';
      /* FALLBACK ONLY - the estimator wins whenever it is loaded. It publishes BB_ZONES /
         BB_ZONE_QS_ETA on PDP AND CART ONLY; everywhere else they are undefined, this
         returned '' and the bar fell back to the retired geo line with no ETA. Owner-reported
         on a CA collection page, 2026-09-24.
         The ETA table below IS a second copy of the card - keep it in step with the
         estimator. BUSINESS days. The zone map is NOT duplicated: see geo.zone below. */
      var _BB_ETA_FB_ETA = {"1":[10,30],"2":[10,30],"3":[10,30],"4":[10,30]};   /* ONE LANE 2026-11-01: 10-30 business days = 2-6 wks, every zone, the only lane there is. Matches the estimator's _LT and the BB_ZONE_ETA / BB_ZONE_QS_ETA it publishes. */
      /* refresh() does `if (_em) newMsgs = [_em]`, so this message OVERRIDES the unserved
         and paused branches. USA ZONES maps AL:7 while AL is UNSERVED, so without this guard
         Alabama was shown a delivery promise. The guard is what lets the map above mirror the
         live ZONES table exactly instead of silently diverging from it. */
      var _BB_ETA_FB_UNS = window.BB_UNSERVED_STATES || {"AL":1,"AR":1,"AK":1,"HI":1,"PR":1,"GU":1,"VI":1,"AS":1,"MP":1};
      if (_BB_ETA_FB_UNS[geo.state]) return '';
      /* ⛔⛔ PAUSED REGIONS TOO. This message OVERRIDES the pause branch below, so without this
         a paused region was shown a delivery promise AND a price for a region checkout refuses.
         Reads the set the estimator publishes — one global, every surface. */
      var _BB_ETA_FB_PAUSED = window.BB_PAUSED_STATES || window.BB_PAUSED_PROVINCES || {};
      if (_BB_ETA_FB_PAUSED[geo.state]) return '';
      /* geo.zone is the banner's OWN ZONES lookup, set by every getGeo() path, so no
         third copy of the zone map is needed here. The estimator still wins when loaded. */
      var _z = (window.BB_ZONES || {})[geo.state] || geo.zone;
      if (!_z) return '';
      /* ⭐⭐ THE DATE AND THE PRICE MUST READ THE SAME LANE. This read __bbLaneCrane, which tracks
         the VIEWED PDP VARIANT, while the price row reads the CART. Measured live 2026-10-17 on a
         pure-Heavy cart: truth was {crane:true,loose:false} and __bbLaneCrane was FALSE, so the
         same card priced Heavy and dated Light. Owner: "in a mixed cart in the pdp and
         announcement the range is soonest to latest" — when the cart holds lanes, the CART wins on
         every surface. ⛔ The viewed variant is the fallback ONLY for a cart with no lane at all. */
      var _cartT = window.__bbCartLanesTruth;
      var _crane = (_cartT && (_cartT.crane || _cartT.loose))
        ? !!_cartT.crane
        : ((typeof window.__bbLaneCrane === 'boolean') ? window.__bbLaneCrane : (window.__bbNeedsCrane === true));
      /* ⛔ _ct FELL BACK TO THE LIGHT TABLE, so anywhere the estimator has not published (which is
         everywhere but the PDP and the cart) a Heavy cart was dated on the LIGHT window —
         understated by exactly the two weeks that separate the lanes in all four zones.
         ⭐ DERIVED, never a second hand-kept table: Heavy is Light + 10 business days in every
         zone of the card (2-4/4-6, 4-6/6-8, 6-8/8-10, 8-10/10-12). */
      var _bbHeavyFb = function(t){ var o={}; for(var z in t){ if(Object.prototype.hasOwnProperty.call(t,z)) o[z]=[t[z][0],t[z][1]]; } return o; }; /* ONE LANE 2026-11-01: was +10 business days on both bounds to synthesise a second, slower lane. There is one lane and one window now, so this is the identity — kept as a function because two call sites read it and a fallback that INVENTS an ETA is worse than one that repeats the real one. */
      var _ct = window.BB_ZONE_ETA || _bbHeavyFb(_BB_ETA_FB_ETA);
      var _lt = window.BB_ZONE_QS_ETA || _BB_ETA_FB_ETA;
      /* ⭐ MIXED CART -> SHORTER WINDOW (owner 2026-10-16). A cart holding both lanes used to take
         the CRANE window here while the PDP card took the loose one, so the two surfaces printed
         different dates for the same cart. Same __bbCartLanes object the FOB reads. */
      var _mxT = window.__bbCartLanesTruth;
      var _mixed = (_mxT && typeof _mxT.loose === 'boolean')
        ? !!(_mxT.loose && _mxT.crane)
        : !!(window.__bbCartLanes && window.__bbCartLanes.loose && window.__bbCartLanes.crane);
      /* ⭐ MIXED = THE FULL SPAN (owner 2026-10-17: "taking the earliest and latest date and
         spanning it — that gives them the full date range within which their orders will arrive").
         A mixed cart arrives on TWO trucks, so the bar now runs from the light low to the crane
         high. ⛔ The previous rule took the SHORTER window, which quoted a date the second truck
         could not meet. Single-lane carts are untouched. */
      var _e;
      if (_mixed && _ct && _ct[_z] && _lt[_z]) _e = [_lt[_z][0], _ct[_z][1]];
      else _e = (_crane && _ct && _ct[_z]) ? _ct[_z] : _lt[_z];
      if (!_e || _e.length < 2) return '';
      var _M = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var _a = _bbAddBd(_e[0]);
      var _b = _bbAddBd(_e[1]);
      var _wm = function (m) { return '<span style="color:#fff">' + _M[m] + '</span>'; };
      var _wd = '<span style="color:#fff">\u2013</span>';
      var _w = (_a.getMonth() === _b.getMonth())
        ? _wm(_a.getMonth()) + ' ' + _a.getDate() + _wd + _b.getDate()
        : _wm(_a.getMonth()) + ' ' + _a.getDate() + ' ' + _wd + ' ' + _wm(_b.getMonth()) + ' ' + _b.getDate();
      /* Rate from the SAME source every other branch uses — resolveTiers(), never a message
         string. Omitted entirely if absent, never printed as undefined. */
      var _r = '';
      try {
        var _t = resolveTiers()[geo.zone];
        if (_t && _t.length && _t[0].label) _r = _t[0].label;
      } catch (e) {}

      /* ⛔⛔ MOBILE CARRIES THE STATE CODE, NEVER THE CITY. Rewritten 2026-09-23 — the old
         note here said NO LOCATION AT ALL, which was true of the CITY form and is now wrong.
         Measured with canvas measureText at the bar's own 600 13.5px Instrument Sans against
         the ~296px phone budget, worst case ($399 + a cross-month range):
           "🚚 Delivered & Unloaded in New Smyrna Beach, FL · FREE · Nov 28 – Dec 12" = 513px  WRAPS
           "🚚 Delivered to CA for $399 · ETA Nov 28 – Dec 12"                  = 309px  WRAPS
           "🚚 Delivered to CA for $399 · Nov 28 – Dec 12"          (live)      = 280px  FITS, 16px
         ⭐ A STATE CODE IS ALWAYS 2 CHARACTERS, so this line's width is CONSTANT. That is the
         whole reason it is safe: the city form varied by city AND by whether the range crossed
         a month, so it wrapped unpredictably rather than never.
         ⛔ 16px is the entire margin. The glyph costs ~21px, " for " ~18px, the word "ETA" ~28px —
         all three do NOT fit together, which is why "ETA" is absent. Re-measure before adding a
         single word, and remember the same-month form ("Oct 7–21") is the NARROW one, so a line
         that fits today can wrap next month.
         ⛔ NO PREPOSITION on desktop either: locationLabel() yields a city ("Portland, OR") or a
         bare state ("Oregon"), and _bbPrep is tuned for "Delivered & Unloaded <prep> X" — reused
         here it produced "Estimated arrival TO Portland, OR", which is not English. */
      var _sep = ' \u00b7 ';
      /* ⭐ THE REMAINING LADDER, DESKTOP ONLY (owner 2026-10-27, "match the PDP chip").
         Derived from resolveTiers() — the same call _r above comes from, and already lane-aware —
         so Light-only, Heavy-only and mixed each print their own figures and the mixed pair agrees
         with the number in front of it. Nothing hardcodes a threshold.
         ⛔ Only bands AHEAD of this cart, and only where the rate actually FALLS: past the step
            this reduces to the free tier, past the free threshold it disappears.
         ⛔ NOT ON MOBILE. That line has ~296px and 16px of margin; the owner kept it as is.
         ⛔ Currency comes off the tier's own LABEL, not money() — money() emits "$" on both
            stores, which would print "for C$348 · FREE at $5,000" on Canada. */
      /* ⛔ THE LADDER CLAUSE WAS REMOVED FROM THIS LINE, 2026-10-27 (owner: "this is way to
         much"). It lived here only because the rotating sale strip below was gated on
         isMobile(), so desktop had nowhere else to show it. Desktop now has its own strip —
         see the DESKTOP SLIDER block near bbSaleMsgs — and the offer belongs there, behind the
         storewide label. ⛔ Do not reinstate it here: this is the ETA OVERRIDE message
         (refresh() does `if (_em) newMsgs = [_em]`), so anything added here is on screen
         permanently and competes with the ETA for a fixed width. */
      /* ⭐ FREE-DELIVERY SUFFIX, DESKTOP ONLY — owner 2026-10-31 asked for the offer back on this
         line. Derived from the first $0 band of the LIVE ladder (never a literal), and '' on
         mobile because _bbFreeSuffix refuses there: the geo line alone is already 278px of a
         ~296px budget. ⛔ BB_SHIP_RATES is in CENTS; convert, or this prints $250,000. */
      var _etaFree = '';
      try {
        var _efL = (window.BB_SHIP_RATES && (window.BB_SHIP_RATES[_z] || window.BB_SHIP_RATES[1])) || null;
        if (_efL && _efL.length && !mobile) {
          _etaFree = _bbFreeSuffix(_efL.map(function (b) { return { min: (+b.min) / 100, rate: +b.rate }; }), false);
        }
      } catch (e) {}
      return mobile
        ? '🚚 Delivered in <span style="color:#FF8A5C;font-weight:800">' + geo.state + '</span>' + (_r ? ' for <span style="color:#FF8A5C;font-weight:800">' + _r + '</span>' : '')
          + _sep + '<span style="color:#fff">ETA</span> <span style="color:#FF8A5C;font-weight:800">' + _w + '</span>'
        : '🚚 Delivered ' + _bbPrep(locationLabel(geo)) + ' <span style="color:#FF8A5C;font-weight:800">' + locationLabel(geo) + '</span>'
          + (_r ? ' <span style="color:#fff">for</span> <span style="color:#FF8A5C;font-weight:800">' + _r + '</span>' : '')
          + _sep + '<span style="color:#fff">ETA</span> <span style="color:#FF8A5C;font-weight:800">' + _w + '</span>' + _etaFree;
    } catch (e) { return ''; }
  }

function _bbPrep(lbl) {
  return (lbl && String(lbl).indexOf(',') !== -1) ? 'to' : 'in';
}

function isMobile() {
    try { return window.matchMedia('(max-width: 600px)').matches; }
    catch (e) { return (window.innerWidth || 9999) <= 600; }
  }

  // Geo-aware shipping math + facility teaser. Mobile (≤600px) gets terse
  // variants ("on-property delivery", state abbrev, dropped connectors) so the strip
  // doesn't squish; desktop keeps the full copy. Re-evaluated on resize.
  function buildMessages(geo, cartTotalCents) {
    var M = isMobile();
    var DLV = M ? 'on-property delivery' : 'BARRIERBOSS Residential Delivery';
    var _rnT = (geo && geo.state) ? (STATE_NAMES[geo.state] || geo.state) : null;
    var locTeaser = (geo && geo.city) ? (geo.city + ', ' + geo.state) : _rnT;
    var link = '<a href="/pages/new-facilities" style="color:#fff;text-decoration:underline;font-weight:600;">' + (M ? 'Our Story →' : 'See Our Growth Story →') + '</a>';
    var facilityMsg = locTeaser
      ? (M ? 'Now Serving <strong>' + (geo.city || geo.state) + '</strong> — ' : 'BARRIERBOSS Proudly Serves <strong>' + locTeaser + '</strong> — ') + link
      : (M ? 'Now Growing in the U.S. — ' : 'BARRIERBOSS Is Expanding Across the United States — ') + link;

    // CORRIDOR HARD-STOP 2026-06-10: paused states get a single pause message,
    // never a rate teaser (checkout zones for these states are removed).
    /* ⛔⛔ THIS FALLBACK IS LIVE BEHAVIOUR, not a safety net: the bar reads it whenever it
       evaluates before the estimator publishes. Corrected 2026-10-21 to the real paused set.
       USA was the old EMPTY crane-paused object, so the bar never showed a pause at all.
       CA listed SK, MB and ON — all KEPT provinces — which showed a pause where we DO deliver.
       ⛔ Keep in lockstep with the delivery profiles and the estimator. */
    var PAUSED = window.BB_PAUSED_STATES || { 'CT':1, 'DE':1, 'DC':1, 'FL':1, 'GA':1, 'IL':1, 'IN':1, 'IA':1, 'KS':1, 'KY':1, 'LA':1, 'ME':1, 'MD':1, 'MA':1, 'MI':1, 'MN':1, 'MS':1, 'MO':1, 'NE':1, 'NH':1, 'NJ':1, 'NY':1, 'NC':1, 'ND':1, 'OH':1,  'PA':1, 'RI':1, 'SC':1, 'SD':1, 'TN':1, 'VT':1, 'VA':1, 'WV':1, 'WI':1 };
    // ⭐⭐ QUICK SHIP CONTIGUOUS EXPANSION 2026-08-12 — lane-aware banner.
    // BEFORE: every one of the 35 eastern states got "All Trucks Full — New Orders Paused",
    // which is now FALSE: checkout accepts them and the PDP quotes a real rate. Owner caught the
    // bar still saying "FL: All Trucks Full ... Reserve Your Q3 2027 Delivery Window".
    // NOW: a state we actually Loose Truck to gets a POSITIVE, DYNAMIC line stating what they can
    // buy, the real starting rate and the real ETA — all read from the live rate card, never
    // hard-coded. Only genuinely unserved states keep the pause + waitlist link.
    var BB_UNSERVED = window.BB_UNSERVED_STATES || { 'AL':1,'AR':1,'AK':1,'HI':1,'PR':1,'GU':1,'VI':1,'AS':1,'MP':1 };
    var BB_Z    = window.BB_ZONES || {};
    var BB_NEWZ = window.BB_QS_NEW_ZONES || { 3:1, 4:1, 7:1 };
    // Extended zones are all 6-8 wks; this fallback only bites before the estimator parses.
    var BB_QETA = window.BB_ZONE_QS_ETA || { 3:[30,40], 4:[20,30], 7:[20,30], 8:[40,50] };
    var bbZid   = geo ? BB_Z[geo.state] : null;
    if (geo && !BB_UNSERVED[geo.state] && bbZid && BB_NEWZ[bbZid]) {
      /* bb-newzone-crane: this branch is only reached in the newly-opened extended zones, and it read
         the LOOSE ladder unconditionally — so a CRANE cart was quoted the loose price ($349 in
         zone 3 where checkout charges $399) and returned before resolveTiers() could correct it.
         Pick the ladder by lane. No crane table -> loose, which understates rather than invents. */
      /* ⭐ same published lane the NAME uses (cart truth, else the VIEWED variant).
         Reading __bbNeedsCrane here kept the RATE on the loose ladder while the name
         already said Crane — verified live on a PDP with an assembled variant. */
      var _bbNZCrane = (typeof window !== 'undefined')
        && (typeof window.__bbLaneCrane === 'boolean' ? window.__bbLaneCrane : window.__bbNeedsCrane === true);
      var bbLad  = ((_bbNZCrane && window.BB_CRANE_RATES) ? window.BB_CRANE_RATES : (window.BB_SHIP_RATES || {}))[bbZid];
      var bbFrom = (bbLad && bbLad.length && bbLad[0].label) ? bbLad[0].label : '';
      var bbEta  = BB_QETA[bbZid] || [40,50];   // extended default, never the old 4-6 wk guess
      // Owner 2026-08-12: week counts read as sticker shock — show a real arrival window instead.
  var _bwM = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var _bwA = new Date(Date.now() + bbEta[0] * 86400000);
  var _bwB = new Date(Date.now() + bbEta[1] * 86400000);
  var bbWk   = (_bwA.getMonth() === _bwB.getMonth())
    ? _bwM[_bwA.getMonth()] + ' ' + _bwA.getDate() + '\u2013' + _bwB.getDate()
    : _bwM[_bwA.getMonth()] + ' ' + _bwA.getDate() + ' \u2013 ' + _bwM[_bwB.getMonth()] + ' ' + _bwB.getDate();
      var bbShop = '<a href="/collections/hog-fencing" style="color:#fff;text-decoration:underline;font-weight:600;">Shop what ships to you →</a>';
      /* ⛔ UNITS: bbLad comes straight from BB_SHIP_RATES / BB_CRANE_RATES, which the estimator
         stores in CENTS (min 500000 = $5,000). _bbFreeSuffix renders money(min) and money() here is
         a plain '$' + round, so handing it the raw ladder would publish "FREE over $500,000".
         Convert to dollars. The normal path never hits this because resolveTiers() converts. */
      var _bbNZFree = (bbLad && bbLad.length)
        ? _bbFreeSuffix(bbLad.map(function (b) { return { min: (+b.min) / 100, rate: +b.rate }; }), M)
        : '';
      return [M
        ? '🚚 <strong>Delivered &amp; Unloaded ' + _bbPrep(locationLabel(geo)) + ' ' + locationLabel(geo) + '</strong>' + (bbFrom ? ' from ' + bbFrom : '') + _bbNZFree
        : '🚚 <strong>Delivered &amp; Unloaded ' + _bbPrep(locationLabel(geo)) + ' ' + locationLabel(geo) + '</strong>' + (bbFrom ? ' from <strong>' + bbFrom + '</strong>' : '') + _bbNZFree];
    }
    /* ⛔ WAS `PAUSED[...] && BB_UNSERVED[...]`, which was DEAD CODE: PAUSED is
       CRANE_PAUSED_STATES and has been deliberately EMPTY since 2026-08-16, so the
       conjunction was permanently false and every unserved state fell through to the
       generic geo line — "Delivered & Unloaded in AL · $149", a delivery promise and a
       price for a state we cannot ship to (verified live 2026-09-24).
       They are two INDEPENDENT reasons to suppress a delivery promise. Do not re-AND
       them, and do not "fix" this by repopulating PAUSED. */
    if (geo && (PAUSED[geo.state] || BB_UNSERVED[geo.state])) {
      // [when, hub] per state — published hub schedule on /pages/new-facilities
      var RESUME = window.BB_RESUME_INFO || {
        'NE':['Q4 2027','Arizona'],'ND':['Q4 2027','Arizona'],'SD':['Q4 2027','Arizona'],'IL':['Q4 2027','Arizona'],'MO':['Q4 2027','Arizona'],'IA':['Q4 2027','Arizona'],'LA':['Q4 2027','Arizona'],'MN':['Q4 2027','Arizona'],'WI':['Q4 2027','Arizona'],'KS':['Q4 2027','Arizona'],
        'MS':['Q1 2028','Georgia'],'AL':['Q1 2028','Georgia'],'GA':['Q1 2028','Georgia'],'FL':['Q1 2028','Georgia'],'TN':['Q1 2028','Georgia'],'KY':['Q1 2028','Georgia'],'SC':['Q1 2028','Georgia'],'NC':['Q1 2028','Georgia'],'PR':['Q1 2028','Georgia'],
        'VA':['Q2 2028','Pennsylvania'],'WV':['Q2 2028','Pennsylvania'],'MD':['Q2 2028','Pennsylvania'],'DC':['Q2 2028','Pennsylvania'],'DE':['Q2 2028','Pennsylvania'],'NJ':['Q2 2028','Pennsylvania'],'PA':['Q2 2028','Pennsylvania'],'NY':['Q2 2028','Pennsylvania'],'CT':['Q2 2028','Pennsylvania'],'MA':['Q2 2028','Pennsylvania'],'VT':['Q2 2028','Pennsylvania'],'NH':['Q2 2028','Pennsylvania'],'ME':['Q2 2028','Pennsylvania'],'RI':['Q2 2028','Pennsylvania'],'MI':['Q2 2028','Pennsylvania'],'OH':['Q2 2028','Pennsylvania'],'IN':['Q2 2028','Pennsylvania']
      };
      var rInfo = RESUME[geo.state] || ['Q4 2027', null];
      var pauseLink = '<a href="/pages/new-facilities" style="color:#fff;text-decoration:underline;font-weight:600;">' + (M ? 'Reserve Your Window →' : 'Reserve Your ' + rInfo[0] + ' Delivery Window →') + '</a>';
      return [M
        ? '🚚 <strong>' + geo.state + ': Trucks Full — New Orders Paused</strong> · Back ' + rInfo[0] + ' — ' + pauseLink
        : '🚚 <strong>' + (locationLabel(geo)) + ': All Trucks Full — New Orders Paused Due to Demand</strong> · Servicing Your Area Again ' + rInfo[0] + (rInfo[1] ? ' via Our New ' + rInfo[1] + ' Hub' : '') + ' — ' + pauseLink];
    }

    // FREIGHT REBUILD 2026-07-09: free-over-$X retired. The bar now STATES the
    // delivery cost by cart value + names the service (Crane when the cart needs
    // it) + leads with the unload moat. Never "free".
    /* ⭐ Prefer the estimator's published lane (cart truth, else the VIEWED variant).
       __bbNeedsCrane is cart-only and showed the loose rate on a crane PDP with an
       empty cart. Kept as the fallback for pages where the estimator never loads. */
    /* ⭐ DERIVED AT RENDER TIME, not read from a global that may be one step stale. The bar
       re-renders on a variant change before the estimator recomputes __bbLaneCrane, and
       bb:ship-rate fires 0x on a PDP so there is no second refresh — reading the global painted
       the PREVIOUS lane. data-bb-crane-ids is emitted by the estimator snippet from
       custom.shipping_mode, so this is the same source, evaluated fresh.
       ⛔ Cart truth still wins when the cart has items. */
    var CRANE = _bbLaneFresh();   /* same owner as the rate, so they cannot disagree */
    /* OUTCOME FIRST 2026-11-03 (owner). The desktop bar led with "BARRIERBOSS Residential
       Delivery" - the internal checkout method name - then restated the moat after a dash.
       The brand is already in the logo above it, so it was 32 characters of nothing. Lead with
       what the shopper GETS. Mobile was already outcome-led and is unchanged.
       Both ternaries here were DEAD: each branch returned the same string, left over from the
       retired two-lane card. CRANE itself is still computed above and has 7 other consumers. */
    var svcValue = M
      ? '🚚 <strong>Delivered &amp; Unloaded</strong>'
      : '🚚 <strong>We unload on your property</strong>';

    if (!geo) {
      // No location yet — but the rate is still knowable, because the card is FLAT: every zone
      // carries the same entry price. Confirm that at runtime and OMIT rather than guess if a
      // reprice ever makes zones differ again.
      var _nt = resolveTiers(), _nlbl = null, _nflat = true;
      for (var _nz in _nt) { var _nf = _nt[_nz] && _nt[_nz][0]; if (!_nf) continue;
        if (_nlbl === null) _nlbl = _nf.label; else if (_nf.label !== _nlbl) _nflat = false; }
      /* ⭐ FREE TIER, REVIVED DERIVED (owner 2026-10-27: "do you work free shipping into ti?").
         The 2026-10-21 note that removed this said it was wrong because it was a LITERAL that no
         reprice could move, and told us to restore it only once a $0 band genuinely exists.
         Measured 2026-10-27: all 16 zone-lanes on both stores carry a $0 band at $5,000.
         ⛔ Stated ONLY if every zone agrees on the same threshold — the same consensus rule
            _nflat applies to the entry price, because with no geo we cannot know the zone.
         ⛔ A band with min 0 is rejected: that would advertise free delivery on every order. */
      var _nfree = '';
      try {
        var _nfMin = null, _nfOk = true, _nfSeen = 0;
        for (var _nfz in _nt) {
          var _nfBands = _nt[_nfz] || [], _nfHit = null;
          for (var _nfi = 0; _nfi < _nfBands.length; _nfi++) {
            if (+_nfBands[_nfi].rate === 0 && +_nfBands[_nfi].min > 0) { _nfHit = +_nfBands[_nfi].min; break; }
          }
          _nfSeen++;
          if (_nfHit === null) { _nfOk = false; break; }
          if (_nfMin === null) _nfMin = _nfHit; else if (_nfMin !== _nfHit) { _nfOk = false; break; }
        }
        if (_nfOk && _nfSeen && _nfMin !== null) {
          var _nfCur = (String(_nlbl || '$').match(/^[^0-9]*/) || ['$'])[0];
          _nfree = (M ? '<br>' : ' \u00b7 ') + '<span style="color:#FF8A5C;font-weight:800">FREE</span> '
            + _nfCur + Math.round(_nfMin).toLocaleString('en-US') + '+';
        }
      } catch (e) {}
      var _nfrom = (_nflat && _nlbl) ? (' for <span style="color:#FF8A5C;font-weight:800">' + _nlbl + '</span>' + _nfree  /* ⭐ RESTORED 2026-10-27, DERIVED. The removal note above was right that a LITERAL goes stale; _nfree is read off the live bands and requires every zone to agree, so it disappears by itself if the free tier is ever retired again. "Flat" dropped: the card steps. */) : '';
      // 2026-08-12: svcValue ALREADY carries the unload line in BOTH branches — "Delivered &
      // Unloaded" on mobile, "We Unload on Your Property" on desktop — so appending the same
      // sentence rendered a visible double-up in the bar. We also cannot claim FREE here: with
      // no geo the zone is unknown and the newly-opened Loose Truck zones have no free band (see
      // the _bbFreeSuffix truth gate). The only genuinely additive thing left is to ask for the
      // ZIP — and only when the flat-rate probe above couldn't produce a "from" price.
      // ⛔ Do NOT prompt for a ZIP here: there is no ZIP field anywhere in the header, so the
      // instruction is unfollowable. Geo is supposed to arrive on its own via detectGeoIfMissing();
      // when it doesn't, the honest move is to say less, not to invent an action. svcValue already
      // carries the service + unload moat, which is true at any value and in any location.
      return [svcValue + _nfrom];
    }
    var loc = locationLabel(geo);
    var locD = M ? (geo.state || loc) : loc;
    var tiers = resolveTiers()[geo.zone] || [];
    if (!tiers.length) return ['🚚 Delivered &amp; Unloaded ' + _bbPrep(locD) + ' <span style="color:#FF8A5C;font-weight:800">' + locD + '</span>' + _bbFreeSuffix(tiers, M)];
    var cartDollars = (cartTotalCents || 0) / 100;
    var minTier = tiers[0]; // lowest tier = regional minimum ($500)
    var currentIdx = -1;
    for (var i = 0; i < tiers.length; i++) { if (cartDollars >= tiers[i].min) currentIdx = i; }

    // Empty cart → "from $149" entry price (no "free"). NOTE: the banner states the
    // COST only; the PDP estimator hero owns the "Delivered & Unloaded for $X" line,
    // so the banner deliberately does NOT repeat "Unloaded" (fixes mobile double-up).
    // The unload moat still lives in svcValue (rotates in) + checkout name + popup.
    if (cartDollars === 0) {
      return [ (M
        ? '🚚 Delivered &amp; Unloaded ' + _bbPrep(locD) + ' <span style="color:#FF8A5C;font-weight:800">' + locD + '</span> · <span style="color:#FF8A5C;font-weight:800">' + minTier.label + '</span>'
        : '🚚 Delivered &amp; Unloaded ' + _bbPrep(loc) + ' <span style="color:#FF8A5C;font-weight:800">' + loc + '</span> · <span style="color:#FF8A5C;font-weight:800">' + minTier.label + '</span>') + _bbFreeSuffix(tiers, M) ];
    }
    // Below the regional minimum → reach-minimum nudge (kept from prior behavior).
    if (currentIdx === -1) {
      var need = minTier.min - cartDollars;
      return [ (M
        ? 'Add <span style="color:#FF8A5C;font-weight:800">' + money(need) + '</span> to reach delivery min'
        : '<strong>' + loc + '</strong>: Add <span style="color:#FF8A5C;font-weight:800">' + money(need) + '</span> to reach the ' + money(minTier.min) + ' delivery minimum') + _bbFreeSuffix(tiers, M) ];
    }
    // In a tier → state the delivery COST only (unload story stays in svcValue + estimator).
    var rateLabel = tiers[currentIdx].label;
    /* ⛔ FAILED CLOSED 2026-09-18: there is no free-delivery tier at any order value, and a banner
     must never invent an offer from a rate it does not recognise. The branch below is kept so a
     future free tier can be revived deliberately; the gate cannot evaluate true from stale data.
     To revive: restore the probe AND verify a $0 band exists on the live delivery profiles. */
  var _isFree = false;
    return [ _isFree
      ? (M ? '🚚 <span style="font-weight:800"><span style="color:#FF8A5C">FREE</span> delivery unlocked</span> · ' + locD
           : '🚚 <span style="font-weight:800"><span style="color:#FF8A5C">FREE</span> delivery unlocked</span> · Delivered &amp; Unloaded ' + _bbPrep(loc) + ' ' + loc)
      : ((M ? '🚚 Delivered &amp; Unloaded ' + _bbPrep(locD) + ' <span style="color:#FF8A5C;font-weight:800">' + locD + '</span> · <span style="color:#FF8A5C;font-weight:800">' + rateLabel + '</span>'
            : '🚚 Delivered &amp; Unloaded ' + _bbPrep(loc) + ' <span style="color:#FF8A5C;font-weight:800">' + loc + '</span> for <span style="color:#FF8A5C;font-weight:800">' + rateLabel + '</span>') + _bbFreeSuffix(tiers, M)) ];
  }

  // Crane = assembled OR loose-heavy (custom.shipping_mode rule): framed (PT/RC),
  // ALL gates, Zero-Maintenance/kits. loose-light = unframed wire → no crane.
  // cart.js exposes no metafields, so classify by title/variant/sku signals.
  function cartNeedsCrane(items) {
    if (!items || !items.length) return false;
    var LIGHT = /\bunframed\b/i;
    var CRANE = /\b(gate|gates|zero[\s-]?maintenance|assembled|framed|pressure[\s-]?treated|cedar|kit)\b/i;
    var CRANE_SKU = /(FRHWFP|FMFPSP|-(PT|RC)\b|\b(PT|RC)-)/i;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var hay = ((it.product_title || it.title || '') + ' ' + (it.variant_title || '') + ' ' + (it.handle || '') + ' ' + (it.product_type || '') + ' ' + (it.sku || ''));
      if (LIGHT.test(hay)) continue; // clearly unframed wire — no crane
      if (CRANE.test(hay) || CRANE_SKU.test(it.sku || '')) return true;
    }
    return false;
  }

  function fetchCartTotal() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { try { window.__bbNeedsCrane = cartNeedsCrane(c.items || []); } catch (e) {} return c.total_price || 0; })
      .catch(function () { return null; });
  }

  /* ⛔ RETIRED: _BB_ZIP_RANGES, a 98-range approximation of the estimator's
     904-prefix table. It DISAGREED with the table that quotes rates — prefix
     246 resolved to VA here and WV in the estimator, and those sit in
     different delivery zones — and it could not resolve 27 prefixes the
     estimator knows, including 202/204/205 (DC), 332/340 (FL) and 842 (UT).
     Now delegates to BBGeo, which carries the estimator's table verbatim. */
  function bbStateFromPostal(raw) {
    if (!window.BBGeo) return null;
    var r = window.BBGeo.resolveCode(raw);
    return r ? r.region : null;
  }

  // Manual location entry, shown ONLY when nothing was detected. Mounted as its own element
  // beside the message span — that span's innerHTML is rewritten on rotation and cart change,
  // which would destroy an input placed inside it and drop focus mid-typing.
  /* ── ZIP/postal -> city + coordinates ─────────────────────────────────────
     The private shard loader that used to sit here (its own cache, its own
     asset-URL derivation, its own base-36 parser) is now BBGeo.resolveCity.
     Same datasets, same laziness — bb-zipcity-{0-9}.js / bb-postalcity.js are
     still fetched only after someone types a code — and the same silent
     failure: an unknown code, a missing shard or a blocked request all leave
     the region-only line standing and say nothing to the shopper. */
  function bbResolveCity(raw, stateCode) {
    if (!window.BBGeo) return;
    window.BBGeo.resolveCity(raw, stateCode, function () {});   /* BBGeo emits bb:geo-change itself */
  }



  function bbZipPrompt() {
    try {
      var bar = document.getElementById('bb-dynamic-banner');
      if (!bar) return;
      var have = !!getGeo();
      var form = document.getElementById('bb-zip-form');
      var chg = document.getElementById('bb-zip-change');
      if (have) {
        if (form) form.parentNode.removeChild(form);
        // Detection is a guess — IP geo, a VPN, or shipping somewhere other than home all make
        // it wrong. Always leave a way to correct it, the same as the PDP.
        if (!chg) {
          chg = document.createElement('button');
          chg.id = 'bb-zip-change';
          chg.type = 'button';
          chg.textContent = 'change';
          chg.setAttribute('style', 'margin-left:8px;background:none;border:0;color:#fff;opacity:.75;'
            + 'font:inherit;font-size:.88em;font-weight:600;text-decoration:underline;cursor:pointer;padding:0;');
          chg.addEventListener('click', function () {
            // Clear the STAMP too — leaving it behind lets a stale owner match a later city
            // from a different state, which is the drift this key exists to prevent.
            try { sessionStorage.removeItem('bb_geo_state'); sessionStorage.removeItem('bb_geo_city'); sessionStorage.removeItem('bb_geo_city_st'); } catch (e) {}
            if (chg.parentNode) chg.parentNode.removeChild(chg);
            document.dispatchEvent(new CustomEvent('bb:geo-change'));   // re-render to the no-geo copy
            bbZipPrompt();                                              // and put the field back
            var i = document.getElementById('bb-zip-input'); if (i) i.focus();
          });
          bar.appendChild(chg);
        }
        return;
      }
      if (chg && chg.parentNode) chg.parentNode.removeChild(chg);
      if (form) return;
      form = document.createElement('form');
      form.id = 'bb-zip-form';
      form.setAttribute('style', 'display:inline-flex;align-items:center;gap:6px;margin-left:10px;vertical-align:middle;');
      var _lbl = 'ZIP';
      var _ph  = '90210';
      var _mx  = 5;
      var _w   = 68;
      var _im  = 'numeric';
      // 16px is the iOS auto-zoom threshold; anything smaller zooms the page on focus. Must come
      // after font:inherit, which resets font-size.
      var _iStyle = 'width:' + (_w + 10) + 'px;padding:4px 7px;border-radius:5px;border:1px solid rgba(255,255,255,.45);background:rgba(255,255,255,.10);color:#fff;font:inherit;font-size:16px;font-weight:600;line-height:1.2;text-align:center;';
      var _bStyle = 'padding:4px 11px;border-radius:5px;border:0;background:#EB673C;color:#fff;font:inherit;font-size:14px;font-weight:700;line-height:1.2;cursor:pointer;';
      form.innerHTML =
        '<label for="bb-zip-input" style="font-weight:600;opacity:.9">' + _lbl + '</label>'
        + '<input id="bb-zip-input" inputmode="' + _im + '" autocomplete="postal-code" maxlength="' + _mx + '" placeholder="' + _ph + '" style="' + _iStyle + '">'
        + '<button type="submit" style="' + _bStyle + '">Go</button>';
      bar.appendChild(form);
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var inp = document.getElementById('bb-zip-input');
        var st = bbStateFromPostal(inp && inp.value);
        if (!st) {
          // Wrong-looking entry must not read as "we don't deliver there" — it's a format issue.
          if (inp) { inp.style.borderColor = '#EB673C'; inp.value = ''; inp.placeholder = 'Check it'; inp.focus(); }
          return;
        }
        // One write. BBGeo.set with no city clears the old city, BOTH ownership
        // stamps and the coordinates together — they belong to wherever the
        // shopper was before, and a half-cleared set is what pairs a city with
        // the wrong region.
        if (window.BBGeo) window.BBGeo.set({ region: st, source: 'user' }, { silent: true });
        if (form.parentNode) form.parentNode.removeChild(form);
        document.dispatchEvent(new CustomEvent('bb:geo-change'));   // state is known NOW — don't wait on the city
        // Then upgrade to the real city + coordinates, so the typed path is as personal as the
        // detected one and "closest ~N mi" can actually be computed.
        bbResolveCity(inp && inp.value, st);
      });
    } catch (e) {}
  }
  function render() {
    if (document.getElementById('bb-dynamic-banner')) return; // already mounted
    var bar = document.createElement('div');
    bar.id = 'bb-dynamic-banner';
    bar.style.cssText =
      'background:#000000;color:#FFFFFF;padding:13px 16px 5px;font-size:' + (isMobile() ? '13.5px' : '15px') + ';font-weight:600;' +
      'text-align:center;line-height:1.35;letter-spacing:0.2px;' +
      'position:relative;top:0;z-index:1000;overflow:hidden;min-height:36px;' +
      'display:flex;align-items:center;justify-content:center;';
    bar.innerHTML = '<span id="bb-dynamic-banner-msg" style="display:inline-block;transition:opacity 0.35s ease;opacity:1;"></span>';
    document.body.insertBefore(bar, document.body.firstChild);

    // BB 2026-08-02: MOBILE only — fold the reviews strip so the 10% bar takes its slot.
    // Desktop keeps "Rated 4.8 ... by 450+ Customers".
    if (!document.getElementById('bb-mobile-header-css')) {
      var mq = document.createElement('style');
      mq.id = 'bb-mobile-header-css';
      mq.textContent = ".header_top .top_navigation_links button.customer_nav_button{font-size:13px !important;font-weight:700 !important;line-height:1 !important;padding:5px 16px !important;border-radius:7px !important;display:inline-flex !important;align-items:center !important;gap:6px !important;white-space:nowrap !important;margin-right:0 !important;}.header_top .top_navigation_links button.customer_nav_button span{font-size:13px !important;font-weight:700 !important;line-height:1 !important;}.header_top .top_navigation_links .customer_nav_menu__wrapper{margin-right:0 !important;padding-right:0 !important;}@media screen and (max-width:749px){html body li.bb-review-strip,html body .bb-review-strip,html body .header_top li.bb-review-strip,html body .top_navigation_links li.bb-review-strip{display:none !important;visibility:hidden !important;height:0 !important;overflow:hidden !important;margin:0 !important;padding:0 !important;}}";
      document.head.appendChild(mq);
    }

    // BB 2026-08-02: black storewide-sale bar, stacked directly under the orange delivery bar.
    if (!document.getElementById('bb-sale-banner')) {
      var saleBar = document.createElement('div');
      saleBar.id = 'bb-sale-banner';
      saleBar.style.cssText =
        'background:#000000;color:#FFFFFF;padding:' + (isMobile() ? '2px 8px 2px' : '6px 8px 4px') + ';font-size:' + (isMobile() ? '13.5px' : '15px') + ';font-weight:600;' +
        'text-align:center;line-height:1.35;letter-spacing:0.2px;position:relative;z-index:999;' +
        'display:flex;align-items:center;justify-content:center;gap:2px;';

      var bbArrowCss = 'background:none;border:0;color:#FFFFFF;opacity:0.55;font-size:20px;line-height:1;' +
        'padding:0 10px;min-width:34px;min-height:30px;cursor:pointer;font-family:inherit;flex:0 0 auto;' +
        '-webkit-tap-highlight-color:transparent;';

      if (isMobile()) {
        saleBar.innerHTML =
          '<button id="bb-sale-prev" type="button" aria-label="Previous announcement" style="' + bbArrowCss + '">\u2039<\/button>' +
          '<span id="bb-sale-msg" style="display:inline-block;transition:opacity 0.35s ease;opacity:1;flex:1 1 auto;">10% Off Storewide. While Supplies Last.<\/span>' +
          '<button id="bb-sale-next" type="button" aria-label="Next announcement" style="' + bbArrowCss + '">\u203A<\/button>';
      } else {
        saleBar.innerHTML = '<span id="bb-sale-msg" style="display:inline-block;transition:opacity 0.35s ease;opacity:1;">10% Off Storewide. While Supplies Last.<\/span>';
      }
      bar.parentNode.insertBefore(saleBar, bar.nextSibling);

      // BB 2026-08-02: MOBILE rotates 10%-off <-> ratings here, because .bb-review-strip is hidden
      // below 750px (inline style set from PAGE context — CSS alone lost to a cross-origin
      // !important rule). That hide is also what removes the STICKY ratings on scroll.
      /* ⭐ ONE SOURCE FOR THE FREE-DELIVERY SLIDE — read by the mobile strip and the desktop
         strip. Derived from the first $0 band of the live tier table, never typed, so a reprice
         carries it. ⛔ A band with min 0 is rejected: it would advertise free delivery on every
         order. ⛔ If it cannot be derived the slide is OMITTED, never guessed — a missing slide
         is recoverable, a wrong threshold is a false advert. */
      function _bbFreeSlideText() {
        try {
          var _bbT = resolveTiers() || {};
          for (var _bbZ in _bbT) {
            var _bbL = _bbT[_bbZ];
            if (!_bbL || !_bbL.length) continue;
            for (var _bbI = 0; _bbI < _bbL.length; _bbI++) {
              if (+_bbL[_bbI].rate === 0 && +_bbL[_bbI].min > 0) {
                return '<span style="color:#FF8A5C;font-weight:800">FREE<\/span>'
                  + ' Delivery on Orders Over <span style="color:#FF8A5C;font-weight:800">' + money(+_bbL[_bbI].min) + '+<\/span>';
              }
            }
          }
        } catch (e) {}
        return '';
      }
      if (isMobile()) {
        var bbHideRatings = function () {
          var n = document.querySelectorAll(".bb-review-strip");
          for (var i = 0; i < n.length; i++) { n[i].style.setProperty("display", "none", "important"); }
          // Collapse the header's top utility row ONLY while nothing in it is visible. On mobile the
          // theme already hides the left column and we hide the reviews strip, leaving an empty row
          // that still claims its full height — the black band under the announcement bars.
          var row = document.querySelector(".header_top");
          if (row) {
            var kids = row.querySelectorAll("li, a, button, img, svg");
            var seen = false;
            for (var k = 0; k < kids.length; k++) {
              var cs = window.getComputedStyle(kids[k]);
              if (cs.display !== "none" && cs.visibility !== "hidden" && kids[k].getBoundingClientRect().height > 0) { seen = true; break; }
            }
            if (seen) { row.style.removeProperty("display"); }
            else { row.style.setProperty("display", "none", "important"); }
          }
        };
        bbHideRatings();
        setTimeout(bbHideRatings, 1200);
        setTimeout(bbHideRatings, 3000);
        window.addEventListener("scroll", function () { bbHideRatings(); }, { passive: true, once: true });

        var bbSaleMsgs = [
          (_bbMobFree || '10% Off Storewide. While Supplies Last.'),
          'Rated 4.8 <span style="color:#FF8A5C;letter-spacing:.5px;">\u2605\u2605\u2605\u2605\u2605<\/span> by 450+ Customers'
        ];
        /* ⭐ FREE-DELIVERY SLIDE (owner 2026-09-23) — moved off the top bar so that stays fixed.
           ⛔ The threshold is DERIVED from the first $0 band, never typed, so a reprice carries
           it automatically. If it cannot be derived the slide is OMITTED rather than guessed —
           a missing slide is recoverable, a wrong threshold is a false advert.
           ⛔ A band with min 0 is rejected: it would advertise free delivery on every order. */
        /* free-delivery slide — derived once, see _bbFreeSlideText() */
        var _bbFreeSlide = _bbFreeSlideText();
        /* ⭐ MOBILE SINGLE SLIDE CARRIES THE OFFER — owner 2026-10-31 ("where's the free on
           mobile?"). The geo line cannot hold a suffix at 296px, and the rotation was switched
           off on 2026-10-29, so this is the only place left. Threshold derived, never literal.
           ⛔ Desktop keeps the Fall Sale wording and is not touched. */
        var _bbMobFree = '';
        try {
          if (isMobile()) {
            var _mT = resolveTiers() || {};
            for (var _mZ in _mT) {
              var _mL = _mT[_mZ];
              if (!_mL || !_mL.length) continue;
              for (var _mI = 0; _mI < _mL.length; _mI++) {
                if (+_mL[_mI].rate === 0 && +_mL[_mI].min > 0) {
                  _bbMobFree = '\uD83C\uDF42 10% Off \u00b7 <span style="color:#FF8A5C;font-weight:800">FREE<\/span> Delivery '
                    + '<span style="color:#FF8A5C;font-weight:800">' + money(+_mL[_mI].min) + '+<\/span>';
                  break;
                }
              }
              if (_bbMobFree) break;
            }
          }
        } catch (e) {}
        if (false && _bbFreeSlide) bbSaleMsgs.push(_bbFreeSlide); /* owner 2026-10-29: single slide, no rotation */
        var bbSaleIdx = 0;
        var bbSaleTimer = null;
        var bbShowSale = function (next) {
          var el = document.getElementById('bb-sale-msg');
          if (!el) return;
          bbSaleIdx = (next + bbSaleMsgs.length) % bbSaleMsgs.length;
          el.style.opacity = '0';
          setTimeout(function () { el.innerHTML = bbSaleMsgs[bbSaleIdx]; el.style.opacity = '1'; }, 350);
        };
        var bbStartSale = function () {
          if (bbSaleTimer) clearInterval(bbSaleTimer);
          bbSaleTimer = setInterval(function () { bbShowSale(bbSaleIdx + 1); }, 5000);
        };
        var bbStep = function (d) { return function (e) { e.preventDefault(); bbShowSale(bbSaleIdx + d); bbStartSale(); }; };
        var bbPrev = document.getElementById('bb-sale-prev');
        var bbNext = document.getElementById('bb-sale-next');
        if (bbPrev) bbPrev.addEventListener('click', bbStep(-1));
        if (bbNext) bbNext.addEventListener('click', bbStep(1));
        bbStartSale();
      }
      /* ⭐ DESKTOP SLIDER, 2026-10-27 (owner: "put the free shipping behind this storewide
         label as a slider"). Until today everything above was gated on isMobile(), so desktop
         got one static line and the freight offer had nowhere to go but the top bar.
         ⛔ NO RATINGS SLIDE HERE. .bb-review-strip is visible on desktop, so rotating a ratings
            message in would state the same claim twice. That slide stays mobile-only, where the
            strip is hidden.
         ⛔ No arrows: the desktop sale bar markup has no prev/next buttons and adding chrome was
            not asked for. It auto-rotates only, and only when there is a second slide to show. */
      if (!isMobile()) {
        var _dSale = ['10% Off Storewide. While Supplies Last.'];
        var _dFree = _bbFreeSlideText();
        if (false && _dFree) _dSale.push(_dFree); /* owner 2026-10-29: single slide, no rotation */
        if (_dSale.length > 1) {
          var _dIdx = 0;
          setInterval(function () {
            var el = document.getElementById('bb-sale-msg');
            if (!el) return;
            _dIdx = (_dIdx + 1) % _dSale.length;
            el.style.opacity = '0';
            setTimeout(function () { el.innerHTML = _dSale[_dIdx]; el.style.opacity = '1'; }, 350);
          }, 5000);
        }
      }
    }

    var currentGeo = null;
    var currentCartTotal = null;
    var msgs = [];
    var idx = 0;
    var rotationTimer = null;

    function refresh() {
      var newMsgs = buildMessages(currentGeo, currentCartTotal);
      /* ⭐ MOBILE: the free offer cannot fit inline on the geo line (measured), so it rotates in
         as its own message. Done HERE rather than at each of buildMessages()'s four return
         points, so no path can be missed. Desktop already carries it inline via _bbFreeSuffix. */
      /* ⭐ TOP BAR IS FIXED (owner 2026-09-23). It carries ONE message — the personalised
         delivery line — and never alternates. The free-delivery offer moved DOWN into the
         sliding strip (bbSaleMsgs) so the top line no longer competes with it, and no longer
         has to fit the threshold inside its width budget.
         ⛔ Rotation stops by itself: refresh() clears rotationTimer when msgs.length <= 1 and
         only re-arms it above 1. Do not re-add a second message here. */
      try {
        var _em = _bbEtaMsg(currentGeo, isMobile(), currentCartTotal);
        if (_em) newMsgs = [_em];
      } catch (e) {}
      msgs = newMsgs;
      var msgEl = document.getElementById('bb-dynamic-banner-msg');
      if (!msgEl) return;
      if (idx >= msgs.length) idx = 0;
      msgEl.style.opacity = '0';
      setTimeout(function () {
        msgEl.innerHTML = msgs[idx];
        msgEl.style.opacity = '1';
      }, 350);
      // Single-message states (FREE unlocked, geo unknown) → kill rotation.
      bbZipPrompt();   // appears only while no location is known; removes itself once it is
      if (msgs.length <= 1 && rotationTimer) {
        clearInterval(rotationTimer);
        rotationTimer = null;
      }
      /* ⭐ ROTATION IS OTHERWISE START-ONCE. startRotation() is called only from the
         detectGeoIfMissing callback at mount, and refresh() above only ever STOPS rotation — so
         if msgs.length was 1 at mount it could never start again. The mobile FREE message is
         appended inside this very function, which flips the count 1 -> 2 whenever geo or the zone
         resolves late, so without this the shopper would never see it.
         ⛔ Guarded on !rotationTimer on purpose: restarting unconditionally would reset the 8s
            interval on every cart update, and someone editing their cart would never reach msg 2. */
      if (msgs.length > 1 && !rotationTimer) startRotation();
    }

    function startRotation() {
      if (rotationTimer) clearInterval(rotationTimer);
      if (msgs.length <= 1) return;
      rotationTimer = setInterval(function () {
        idx = (idx + 1) % msgs.length;
        var msgEl = document.getElementById('bb-dynamic-banner-msg');
        if (!msgEl) return;
        msgEl.style.opacity = '0';
        setTimeout(function () {
          msgEl.innerHTML = msgs[idx];
          msgEl.style.opacity = '1';
        }, 350);
      }, 8000);
    }

    detectGeoIfMissing(function (geo) {
      currentGeo = geo;
      fetchCartTotal().then(function (total) {
        currentCartTotal = total;
        refresh();
        startRotation();
        bbZipPrompt();
      });
    });

    // Refresh banner whenever cart changes (theme dispatches events, AJAX cart, etc.)
    function refreshCartThenRender() {
      fetchCartTotal().then(function (total) {
        if (total !== currentCartTotal) {
          currentCartTotal = total;
          // Reset to first (cart-state) message so customer sees the live update
          idx = 0;
          refresh();
        }
      });
    }
    document.addEventListener('cart:updated', refreshCartThenRender);
  // Fires on SET and on CLEAR — "change" clears the location, and the bar must drop back to the
  // no-geo copy rather than keep showing the old city and price.
  document.addEventListener('bb:geo-change', function () { currentGeo = getGeo(); idx = 0; refresh(); });
  /* ⭐ The bar paints before the cart is known. cart-items.liquid publishes __bbCartLanesTruth
     server-side and fires this; without the re-render the bar keeps whatever lane it guessed on
     first paint, which is why the wrong rate "stuck" on some loads and not others. */
  document.addEventListener('bb:cart-lanes', function () { try { refresh(); } catch (e) {} });
    document.addEventListener('on:cart:after-update', refreshCartThenRender);
    // POLLING BACKOFF (2026-08-13). This ran every 2.5s forever, in every tab, visible or not —
    // ~24 req/min/visitor. It tripped Shopify's cart throttle (429 on /cart.js, /cart/add.js and
    // /cart/clear.js) during ordinary testing, and a 429 on ADD is an add that silently fails: the
    // theme's .catch swallows it and the shopper sees nothing. The listeners above already catch
    // every change made in THIS tab; the timer only exists to notice a change made in another one,
    // which does not need 2.5-second resolution.
    var _bbFastUntil = 0, _bbTick = 0;
    function _bbFast() { _bbFastUntil = Date.now() + 20000; }
    document.addEventListener('cart:updated', _bbFast);
    document.addEventListener('on:cart:after-update', _bbFast);
    // Coming back to the tab is exactly when another tab may have changed the cart — catch up once
    // immediately, then stay responsive for a bit.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { _bbFast(); refreshCartThenRender(); }
    });
    setInterval(function () {
      if (document.hidden) return;                        // a hidden tab cannot show the bar
      if (Date.now() < _bbFastUntil) { refreshCartThenRender(); return; }
      _bbTick = (_bbTick + 1) % 8;                        // 8 x 2.5s -> one poll per 20s when idle
      if (_bbTick === 0) { refreshCartThenRender(); }
    }, 2500);

    /* ⛔⛔ GEO CAN ARRIVE AFTER MOUNT, SILENTLY — without this the rate and the ETA are simply
       never shown to a cold visitor. Observed live 2026-09-23: sessionStorage held bb_geo_state=UT
       while the bar still read the generic "We Unload on Your Property" line, with rotation dead.
       The chain: detectGeoIfMissing() -> BBGeo.resolveIP() FAILS (ipapi is blocked, see
       reference_banner_geo_ipapi_blocked) -> cb(null) -> the no-geo copy renders, and being a
       SINGLE message it kills rotation. bb-order-proof then fills bb_geo_state from its OWN
       provider about a second later using { silent: true }, which dispatches NO 'bb:geo-change',
       so the listener below never fires and nothing ever re-reads it.
       ⭐ BOUNDED CATCH-UP, not a poll: it cancels the moment geo lands OR after ~6s, and never
       re-arms. (A forever 2.5s poll was removed from this file on 2026-08-13 — do not reintroduce
       one.) Self-cancels immediately if the normal path already set currentGeo.
       ⭐ Deliberately HERE, beside the resize handler: idx, refresh and currentGeo are the
       closure's own. The comment below records that an earlier hook placed after the closure threw
       ReferenceError and a catch{} hid it. */
    var _bbGeoTries = 0;
    var _bbGeoWait = setInterval(function () {
      if (currentGeo || ++_bbGeoTries > 60) { clearInterval(_bbGeoWait); return; }
      var _g = getGeo();
      if (!_g) return;
      clearInterval(_bbGeoWait);
      currentGeo = _g; idx = 0; refresh(); bbZipPrompt();
    }, 500);

    // Re-evaluate mobile/desktop copy on viewport change (rotate/resize), debounced.
    var _rzT;
    window.addEventListener('resize', function () {
      clearTimeout(_rzT);
      _rzT = setTimeout(function () { idx = 0; refresh(); }, 300);
    });

    /* ⭐ IN SCOPE HERE (beside the resize handler): idx and refresh() are the closure's own.
       An earlier copy of this sat after the closure closed, so it threw ReferenceError and
       the catch{} hid it — the bar never moved. bb:ship-rate is kept because it is correct
       where it fires (cart changes); it measures ZERO events on a PDP, hence the DOM hooks. */
    document.addEventListener('bb:ship-rate', function () { try { currentGeo = getGeo(); idx = 0; refresh(); } catch (e) {} });
    var _bbLaneDeb;
    function _bbLaneRerender() {
      clearTimeout(_bbLaneDeb);
      /* 260ms lands AFTER the estimator's own 120ms debounce, so __bbLaneCrane is fresh */
      /* currentGeo too — refresh() composes via buildMessages(currentGeo, ...) and the
         generic no-geo message ignores the lane entirely. Same shape as bb:geo-change. */
      _bbLaneDeb = setTimeout(function () { currentGeo = getGeo(); idx = 0; refresh(); }, 260);
    }
    document.addEventListener('change', _bbLaneRerender, true);
    document.addEventListener('on:variant:change', _bbLaneRerender);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
